import { AUTH_ACCEPT_INVITATION, AUTH_ACCEPT_INVITATION_FAILED, AUTH_ACCEPT_INVITATION_SUCCESS } from './types';
import { apiAction } from '../../api/actions';
import { AUTH_LOGIN_SUCCESS } from '../login/types';

export function acceptInvitation(token, email, password, onSuccess, onFailure) {
  return apiAction({
    resource: '/auth/accept-invitation',
    method: 'POST',
    data: {
      token,
      email,
      password
    },
    onSuccess: (data) => onSuccessAcceptInvitation(data, onSuccess),
    onFailure: (error) => onFailedAcceptInvitation(error, onFailure),
    carry: {
      label: AUTH_ACCEPT_INVITATION
    },
  });
}

function onSuccessAcceptInvitation(data, onSuccess) {
  // If the backend returns user and token (auto-login), dispatch login success
  if (data.user && data.token) {
    // Save session data
    localStorage.setItem('token', data.token);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('tenant', data.tenant);

    onSuccess();

    // Return login success action to update Redux state
    return {
      type: AUTH_LOGIN_SUCCESS,
      payload: {
        user: data.user,
        token: data.token,
        tenant: data.tenant
      }
    };
  }

  // Fallback for old behavior
  onSuccess();
  return {
    type: AUTH_ACCEPT_INVITATION_SUCCESS,
    payload: data
  };
}

function onFailedAcceptInvitation(error, onFailure) {
  // Pass translation key to onFailure, component will translate it
  let translationKey = 'accept-invitation.error-default';
  
  if (error?.response?.data?.error === 'EXPIRED_TOKEN') {
    translationKey = 'accept-invitation.error-expired';
  } else if (error?.response?.data?.error === 'TOKEN_ALREADY_USED') {
    translationKey = 'accept-invitation.error-already-used';
  } else if (error?.response?.data?.error === 'INVALID_TOKEN') {
    translationKey = 'accept-invitation.error-invalid';
  } else if (error?.response?.data?.message) {
    // If backend provides a message, use it directly
    translationKey = error.response.data.message;
  }
  
  onFailure(translationKey);
  return {
    type: AUTH_ACCEPT_INVITATION_FAILED,
    payload: {
      error
    }
  };
}
